import React from 'react';
import { DatePicker } from 'antd';
import type { Dayjs } from 'dayjs';
import { useFilterLabelClassName, useFilterContainerClassName, useFilterInputContainerClassName } from '../../../utils/languageUtils';

interface DayjsRangePickerFilterItemProps {
    label: string;
    value?: [Dayjs, Dayjs] | null;
    onChange?: (range: [Dayjs, Dayjs] | null) => void;
    className?: string;
    spanClassName?: string;
    picker?: 'date' | 'week' | 'month';
    format?: string | ((value: Dayjs) => string);
    disabledDate?: (current: Dayjs) => boolean;
    allowClear?: boolean;
}

const DayjsRangePickerFilterItem: React.FC<DayjsRangePickerFilterItemProps> = ({
    label,
    value,
    onChange,
    className,
    spanClassName,
    picker = 'date',
    format,
    disabledDate,
    allowClear = true
}) => {
    const containerClassName = useFilterContainerClassName(className, true);
    const labelClassName = useFilterLabelClassName(spanClassName);
    const inputContainerClassName = useFilterInputContainerClassName();

    return (
        <div className={containerClassName}>
            <span className={labelClassName}>{label}</span>
            <div className={inputContainerClassName}>
                <DatePicker.RangePicker
                    picker={picker}
                    value={value ?? null}
                    onChange={(dates) => {
                        if (!dates || !dates[0] || !dates[1]) {
                            onChange?.(null);
                            return;
                        }
                        onChange?.([dates[0], dates[1]]);
                    }}
                    allowClear={allowClear}
                    format={format as any}
                    disabledDate={disabledDate as any}
                    size="middle"
                    style={{ width: '100%' }}
                />
            </div>
        </div>
    );
};

export default DayjsRangePickerFilterItem;

